import React, { Component } from 'react';
import Box from 'grommet/components/Box';
import Label from 'grommet/components/Label';
import Layer from 'grommet/components/Layer';
import Header from 'grommet/components/Header';
import Footer from 'grommet/components/Footer';
import Title from 'grommet/components/Title';
import Menu from 'grommet/components/Menu';
import Button from 'grommet/components/Button';
import CloseIcon from 'grommet/components/icons/base/Close';
//import SessionMenu from './SessionMenu';
//import Anchor from 'grommet/components/Anchor';
import Data from './data/Data'
import {statisticsFitModel, statisticsExplore} from "./data/Data"

const components = Data;
class NavSidebar extends Component {

  constructor() {
    super();
    this.onClickExplore = this.onClickExplore.bind(this);
    this.onClickFitModel = this.onClickFitModel.bind(this);
    this._onClose = this._onClose.bind(this);
  }
  onClickExplore(component) {
    this.props.onSelectExplore(component)
  }
  onClickFitModel(component) {
    this.props.onSelectFitModel(component)
  }

  _onClose() {
    this.props.onClose();
  }

  render() {
    const links1 = statisticsExplore.map((item, key) => {
      return (
              <Box direction='row'
                  align='center'
                  wrap={true}
                  pad='small'
                  margin='none'>
                  {/* <Icon size={"xsmall"} colorIndex="grey-1"/> */}
                  <Box direction='row'
                  align='center'
                  wrap={true}
                  pad='small'
                  margin='none'>
                      {(item.name)? <a onClick={this.onClickExplore.bind(this, key)}><Label>{item.name}</Label></a> : <div><b>{item.name}</b></div> }
                  </Box>
              </Box>
      );
    });
    const links2 = statisticsFitModel.map((item, key) => {
      return (
              <Box direction='row'
                  align='center'
                  wrap={true}
                  pad='small'
                  margin='none'>
                  {/* <Icon size={"xsmall"} colorIndex="grey-1"/> */}
                  <Box direction='row'
                  align='center'
                  wrap={true}
                  pad='small'
                  margin='none'>
                      {(item.name)? <a onClick={this.onClickFitModel.bind(this, key)}><Label>{item.name}</Label></a> : <div><b>{item.name}</b></div> }
                  </Box>
              </Box>
      );
    });

    return (
      <Layer closer={false}
      flush={false}
      align='left'>
        <Header size="large" justify="between" pad={{horizontal: 'medium'}}>
          <Title onClick={this._onClose} a11yTitle="Close Menu">
            Prophesier
          </Title>
          <Button icon={<CloseIcon />} onClick={this._onClose} plain={true}
            a11yTitle="Close Menu" />
        </Header>
        <Menu fill={true} primary={true}>
          {links1}
          {links2}
        </Menu>
        <Footer pad={{horizontal: 'medium', vertical: 'small'}}>
          
        </Footer>
      </Layer>
    );
  }
}




export default NavSidebar;


// WEBPACK FOOTER //
// ./src/Sidebar.js